/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import insuranceIcon from "../../assets/icons/progress/icon_progressbar_versicherung.svg";
import documentsIcon from "../../assets/icons/progress/icon_progressbar_vertrag_upload.svg";
import documentIcon from "../../assets/icons/progress/icon_progressbar_document.svg";

const progressBarSteps = [
  {
    key: "concern",
    name: "Ihr Anliegen",
    icon: documentIcon,
  },
  {
    key: "documents",
    name: "Unterlagen",
    icon: documentsIcon,
  },
  {
    key: "insurance",
    name: "Versicherung",
    icon: insuranceIcon,
  },
];

export default progressBarSteps;
